import React from 'react';
import PropTypes from 'prop-types';
import QuizCard from "../QuizCard/quizCard";
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";

/**
 * Quiz list section for web.
 * @param props
 * @returns {*}
 * @constructor
 */
function QuizListSection(props) {
    const { quizSectionList, showVertical, handleRefresh, onQuizCardClick, startQuiz, course_id, showInstructions, showInstructionScreen, progressPercent, courseName, attemptsRemaining, quizTotalAttempts, isUserCertified, certificationToggle  } = props;
    const t = useTranslations();

    return (
        <div>
                    <div className={"flexBox-container " + (showVertical ? 'saved-quiz-container' : '')}>
                        {
                            quizSectionList.map((data) => {
                                const quizKey = data?._id || data?.testId?._id || data?.testId?.slug || data?.testId?.name;
                                return (
                                    <React.Fragment key={quizKey}>
                                        <QuizCard quizData={data} t={t} handleRefresh={handleRefresh} onQuizCardClick={onQuizCardClick} startQuiz={startQuiz} course_id={course_id} courseName={courseName} showInstructions={showInstructions} showInstructionScreen={showInstructionScreen} progressPercent={progressPercent} attemptsRemaining={attemptsRemaining} quizTotalAttempts={quizTotalAttempts} isUserCertified={isUserCertified} certificationToggle={certificationToggle}/>
                                    </React.Fragment>
                                );
                            })
                        }
            </div>
        </div>
    );
}

QuizListSection.propTypes = {
    quizSectionList: PropTypes.arrayOf(
        PropTypes.shape({
            _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            testId: PropTypes.shape({
                _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                slug: PropTypes.string,
                name: PropTypes.string,
            }),
        })
    ),
    showVertical: PropTypes.bool,
    handleRefresh: PropTypes.func,
    onQuizCardClick: PropTypes.func,
    startQuiz: PropTypes.func,
    course_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    showInstructions: PropTypes.bool,
    showInstructionScreen: PropTypes.func,
    progressPercent: PropTypes.number,
    courseName: PropTypes.string,
    attemptsRemaining: PropTypes.number,
    quizTotalAttempts: PropTypes.number,
    isUserCertified: PropTypes.bool,
    certificationToggle: PropTypes.bool,
};

export default QuizListSection;
